import Logger from '@/utils/CapcitorLog';

import { NativeQSenseControlPlugin } from '@/plugins/NativeQSenseControl';
import { QSenseHubControlPlugin } from '@/plugins/QSenseHubControl';

import { IListenerRegistry } from '../interfaces/IListenerRegistry';

export class ListenerRegistry implements IListenerRegistry {
  private listeners: Map<
    string,
    Awaited<ReturnType<NativeQSenseControlPlugin['addListener'] | QSenseHubControlPlugin['addListener']>>
  > = new Map();

  constructor(private plugin: NativeQSenseControlPlugin | QSenseHubControlPlugin) {}

  async add<Event extends string, Payload>(
    event: Event,
    handler: (payload: Payload) => void,
    nameOverride?: string,
  ): Promise<void> {
    const listener = await this.plugin.addListener(event, handler);
    Logger.info('Added listeners', {
      event: nameOverride ?? event,
    });

    this.listeners.set(nameOverride ?? event, listener);
  }

  remove(eventName: string): void {
    const listener = this.listeners.get(eventName);

    if (listener) {
      listener.remove();
      this.listeners.delete(eventName);
    }
  }

  removeAll() {
    for (const listener of this.listeners.values()) {
      listener.remove();
    }

    this.listeners.clear();
  }
}
